export const formatFileName = (fileName: string): [string, string] => {
  // Get last 3 characters of file name and extension
  const [suffix] = fileName.match(/(?:[\\.\w\d\s]{4}([^.]+))?$/);

  // remove suffix from file name
  const name = fileName.replace(suffix, '');

  return [name, suffix];
};
